import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { isEmpty } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: RemediationEvents
 *
 * Displays remediation information about the risk record.
 *
 * @param riskRecord
 * @returns {Element}
 * @constructor
 */
export function RemediationEvents({
  riskRecord = {
    remediation: {
      remediationEvents: [],
    },
  },
}) {
  const remediationEvents = riskRecord?.remediation?.remediationEvents || [];

  return (
    <ErrorHandler location="src/widgets/RiskRecords/RemediationEvents/RemediationEvents.jsx">
      {isEmpty(remediationEvents) ? (
        <Alert title="There are no remediation events for this risk record." variant="info" />
      ) : (
        <Table rows={remediationEvents} />
      )}
    </ErrorHandler>
  );
}
